export const INVITE_PATHS = Object.freeze({
  GUEST: '/guest',
  SMART_LOCK: '/guest/fechadura',
  PERSONALIZED_INVITE_GENERATOR: '/convite-personalizado/gerador',
});

export const buildInvitePath = (path, guestHash) => `${path}?q=${guestHash}`;

export const INVITE_BRAND_VARIANTS = Object.freeze({
  PORTER: 'porter',
  KIPER: 'kiper',
});

export const getInviteBrandVariant = isPorterPartner =>
  isPorterPartner ? INVITE_BRAND_VARIANTS.PORTER : INVITE_BRAND_VARIANTS.KIPER;
